<script>
import Popper from "vue3-popper";
import { format } from 'date-fns'

export default {
	name: 'UserCircle',
	
	components: {
		Popper
	},
	
	data() {
		return {
			datas:[],
			isSelected:false,
			isLight:true,
			mainColor:'#000',
			format
		}
	},
	
	props: {'firstName': String, 'surName': String, 'color': String, 'date': String },
	emits: [],

	mounted:function(){
		if(this.color){
			this.lightOrDark(this.color);
		}
	},
	
	methods: {
		lightOrDark:function(color) {
			
			var r, g, b, hsp;

			// Check the format of the color, HEX or RGB?
			if (color.match(/^rgb/)) {

				// If HEX --> store the red, green, blue values in separate variables
				color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

				r = color[1];
				g = color[2];
				b = color[3];
			} else {

				// If RGB --> Convert it to HEX: http://gist.github.com/983661
				color = +("0x" + color.slice(1).replace( 
					color.length < 5 && /./g, '$&$&'
				)
						);

				r = color >> 16;
				g = color >> 8 & 255;
				b = color & 255;
			}

			// HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
			hsp = Math.sqrt(
				0.299 * (r * r) +
				0.587 * (g * g) +
				0.114 * (b * b)
			);

			// Using the HSP value, determine whether the color is light or dark
			if (hsp>127.5) {
				this.isLight=true;
			} 
			else {
				this.isLight=false;
			}
		}
	},	
	
	watch: {
		color() {
			this.lightOrDark(this.color);
		},
	},

	computed:{
		
	},
	
} 
</script>

<template>

	<div v-if="date && date !== '0000-00-00 00:00:00'">
		<Popper :content="`${firstName ? firstName : ''} ${surName ? surName : ''} ${firstName || surName ? ',' : ''} ${format(new Date(date), 'dd.MM.yyyy HH:mm')}`">
			<button class="personCircle v-center" :class="{'dark':isLight,'light':!isLight}" v-bind:style="{background:color}" >
				<span v-if="firstName">{{ `${firstName.substring(0, 1)}` }}</span>
				<span v-if="surName">{{ `${surName.substring(0, 1)}` }}</span>
			</button>
		</Popper>
	</div>
</template>


